export default function TbCW({data}) {
    let lastReading = data.data;

    return (
      <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">Condensed Whey</h4>
          </div>
          <div className="card-body nopadding">
            <table className="table table-sm my-0 tbl">
              <thead>
                <tr>
                  <th scope="col">Silo</th>
                  <th scope="col">Lbs</th>
                  <th scope="col">Temp</th>
                </tr>
              </thead>
              <tbody>
                <tr hidden={lastReading.cw_cl1_rawmilk}>
                  <td>CL 1</td>
                  <td>{lastReading.cw_cl1_lbs}</td>
                  <td>{lastReading.cw_cl1_temp}</td>
                </tr>
                <tr>
                  <td>CL 2</td>
                  <td>{lastReading.cw_cl2_lbs}</td>
                  <td>{lastReading.cw_cl2_temp}</td>
                </tr>
                <tr>
                  <td>WP 1</td>
                  <td>{lastReading.cw_wp1_lbs}</td>
                  <td>{lastReading.cw_wp1_temp}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
}